import useSWR from 'swr';

import { fetchEndpointData } from '../../utils/fetchEndpointData';
import type {
  TelerouteConnectBody,
  TelerouteConnectResponse,
  TelerouteDisconnectResponse,
} from './endpoints/TelerouteConnectEndpoint.types';

import type { SpotMarketOffersResponse } from './endpoints/SpotMarketOffersEndpoint.types';
import type { SpotMarketWithdrawResponse } from './endpoints/SpotMarketWithdrawEndpoint.types';
import type { SpotPricingPushBody, SpotPricingPushResponse } from './endpoints/SpotPricingPushEndpoint.types';
import type { SpotPricingProvidersResponse } from './endpoints/SpotPricingProvidersEndpoint.types';

export async function connectTeleroute(body: TelerouteConnectBody): Promise<TelerouteConnectResponse> {
  return fetchEndpointData<TelerouteConnectResponse>('/api/v1/spot-pricing/teleroute/connect', {
    method: 'POST',
    body,
  });
}

export async function disconnectTeleroute(): Promise<TelerouteDisconnectResponse> {
  return fetchEndpointData<TelerouteDisconnectResponse>('/api/v1/spot-pricing/teleroute/disconnect', {
    method: 'POST',
  });
}

// --- Spot market offers ---

export async function getSpotMarketOffers(orderId: string): Promise<SpotMarketOffersResponse> {
  return fetchEndpointData<SpotMarketOffersResponse>(`/api/v1/orders/${orderId}/spot-pricing/offers`);
}

export function useSpotMarketOffers(orderId: string) {
  return useSWR(['spot-market-offers', orderId], () => getSpotMarketOffers(orderId));
}

export async function pushToSpotMarket(orderId: string, body: SpotPricingPushBody): Promise<SpotPricingPushResponse> {
  return fetchEndpointData<SpotPricingPushResponse>(`/api/v1/orders/${orderId}/spot-pricing/push`, {
    method: 'POST',
    body,
  });
}

export async function withdrawSpotMarketOffer(orderId: string, offerId: string): Promise<SpotMarketWithdrawResponse> {
  return fetchEndpointData<SpotMarketWithdrawResponse>(
    `/api/v1/orders/${orderId}/spot-pricing/offers/${offerId}/withdraw`,
    { method: 'POST' },
  );
}

export async function getSpotPricingProviders(): Promise<SpotPricingProvidersResponse> {
  return fetchEndpointData<SpotPricingProvidersResponse>('/api/v1/spot-pricing/providers');
}

export function useSpotPricingProviders() {
  return useSWR('spot-pricing-providers', getSpotPricingProviders, {
    revalidateOnFocus: false,
  });
}
